import { render, staticRenderFns } from "./SetupPureDeviceType.vue?vue&type=template&id=43eb9216"
import script from "./SetupPureDeviceType.vue?vue&type=script&lang=js"
export * from "./SetupPureDeviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports